import { createMuiTheme } from '@material-ui/core/styles'
import { identity } from './brand'


const theme = createMuiTheme({
  brand: identity,
  shape: {
    borderRadius: 4,
  },
  palette: {
    primary: {
      light: '#005795',
      main: '#1C408C',
      dark: '#1F2532',
      contrastText: '#fff',
    },
    secondary:{
      light: '#FF7043',
      main: '#FF7043',
      dark: '#FF7043',
      contrastText: '#FF7043'
    },
    accent: '#FF7043',
    success: '#4caf50',
    fail: '#ff5252',
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
      icon: 'rgba(0, 0, 0, 0.38)',
      divider: 'rgba(0, 0, 0, 0.12)',
      lightDivider: 'rgba(0, 0, 0, 0.075)',
    },
    input: {
      bottomLine: 'rgba(0, 0, 0, 0.42)',
      helperText: 'rgba(0, 0, 0, 0.54)',
      labelText: 'rgba(0, 0, 0, 0.54)',
      inputText: 'rgba(0, 0, 0, 0.87)',
      disabled: 'rgba(0, 0, 0, 0.42)',
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.26)',
    },
    background: {
      paper: '#fff',
      default: '#fafafa',
      appBar: '#f5f5f5',
      contentFrame: '#eeeeee',
      chip: '#e0e0e0',
      avatar: '#bdbdbd',
    },
    line: {
      stepper: '#bdbdbd',
    },
  },
  overrides: {
    MuiButton: {
      raisedPrimary: {
        color: 'white',
      },
    },
  },
  props: {
    MuiModal: {
      disableEnforceFocus: true,
    },
  }
})

export default theme
